<template>
  <transition name="fade">
    <div class="mod-req-app">
      <div class="mod-req-app-container">
        <div class="btn-close" @click="closeModal()">
          X
        </div>
        <div class="title-wrapper">
          <div class="title-big title-color__red">
            EXTEND TO SAP
          </div>
        </div>
        <div>Nama Vendor</div>
        <div class="half-input-wrapper">
          <v-select class="style-chooser" placeholder="Cari Vendor" label="nama_vendor" :options="vendors"
            v-model="choosedVendor" @search="typingVendor" />
        </div>
        <div>
          <div>Bisnis Unit</div>
          <div class="flex-space-between">
            <div>
              <input type="radio" value="2" v-model="bisnis_unit" class="mr10" :disabled="gemsReady" />
              <label>GEMS</label>
            </div>
            <div>
              <input type="radio" value="1" v-model="bisnis_unit" class="mr10" :disabled="bceReady" />
              <label>BCE</label>
            </div>
            <div>
              <input type="radio" value="3" v-model="bisnis_unit" class="mr10" :disabled="bkesReady" />
              <label>BKES</label>
            </div>
          </div>
        </div>
        <div>
          <div>Catatan</div>
          <input type="text" class="input-100" v-model="note" />
        </div>
        <div class="mt20 text-grey text-small">
          Catatan: Jika legalitas dokumen belum lengkap, mohon untuk menunggu
          SIPM untuk meminta vendor melengkapi dokumen Legalitas terlebih dahulu
        </div>
      </div>
      <div class="one-btn-center">
        <div class="btn-big">
          <div class="btn-wrapper btn-wrapper__red" @click="submit()">
            Submit
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      vendors: [],
      // choosedVendor: [],
      bisnis_unit: 0,
      note: null,
      gemsReady: false,
      bceReady: false,
      bkesReady: false,
    }
  },
  mounted() {
    if (this.$store.state.myRequest.isExtend) {
      this.getVendorMounted(
        this.$store.state.myRequest.nama_vendor,
        this.$store.state.myRequest.alias_profile
      )
    }
  },
  computed: {
    choosedVendor: {
      get() {
        return this.$store.state.myRequest.choosedVendor
      },
      set(newValue) {
        // if (newValue && newValue.gems_code) this.gemsReady = true
        // if (newValue && newValue.bce_code) this.bceReady = true
        // if (newValue && newValue.bkes_code) this.bkesReady = true

        this.$store.commit('myRequest/SET_DATA', {
          name: 'choosedVendor',
          value: newValue,
        })
      },
    },
  },
  methods: {
    checkForm() {
      let arr = [
        [this.choosedVendor, 'Nama Vendor'],
        [this.bisnis_unit, 'Bisnis Unit'],
      ]

      return this.multiConditions(arr)
    },
    submit() {
      if (this.checkForm()) {
        this.$store.dispatch('myRequest/createRequest', {
          type: '2',
          vendor: this.choosedVendor.id,
          bisnis_unit: this.bisnis_unit,
          note: this.note,
        })
      }
    },
    closeModal() {
      this.$store.commit('myRequest/CANCEL_EXTEND')
      this.$store.commit('modalReqApp/SET_VALUE', {
        name: 'modalExtendSap',
        value: false,
      })
    },
    typingVendor(search, loading) {
      if (search.length > 2 && search.length < 4) {
        this.getVendor(search)
      }
    },
    async getVendor(search) {
      this.vendors = await this.$vendorName(search)
    },
    async getVendorMounted(nama_vendor, alias_profile) {
      let vendor = await this.$vendorName(nama_vendor)
      let filterVendor = ''
      if (vendor && vendor.length > 0) {
        filterVendor = vendor.filter(
          i => i.nama_vendor == nama_vendor + ', ' + alias_profile
        )
      }
      this.choosedVendor = filterVendor[0]
    },
  },
}
</script>
